// extracted by mini-css-extract-plugin
export default {"backButton":"_BackButton_backButton__p2BB1"};